import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { extractEventInfo } from '../events/event-info.mjs';
import { addDomEvent } from '../events/add-dom-event.mjs';
import { addPointerEvent } from '../events/add-pointer-event.mjs';
import { Feature } from '../motion/features/Feature.mjs';
import { pipe } from '../utils/pipe.mjs';
import { isDragActive } from './drag/utils/lock.mjs';
import { isNodeOrChild } from './utils/is-node-or-child.mjs';
import { noop } from '../utils/noop.mjs';
import { frame } from '../frameloop/frame.mjs';
function fireSyntheticPointerEvent(name, handler) {
  if (!handler) return;
  var syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
var PressGesture = /*#__PURE__*/function (_Feature) {
  function PressGesture() {
    var _this;
    _classCallCheck(this, PressGesture);
    _this = _callSuper(this, PressGesture, arguments);
    _this.removeStartListeners = noop;
    _this.removeEndListeners = noop;
    _this.removeAccessibleListeners = noop;
    _this.startPointerPress = function (startEvent, startInfo) {
      if (_this.isPressing) return;
      _this.removeEndListeners();
      var props = _this.node.getProps();
      var endPointerPress = function endPointerPress(endEvent, endInfo) {
        if (!_this.checkPressEnd()) return;
        var _this$node$getProps = _this.node.getProps(),
          onTap = _this$node$getProps.onTap,
          onTapCancel = _this$node$getProps.onTapCancel,
          globalTapTarget = _this$node$getProps.globalTapTarget;
        frame.update(function () {
          /**
           * We only count this as a tap gesture if the event.target is the same
           * as, or a child of, this component's element
           */
          !globalTapTarget && !isNodeOrChild(_this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
        });
      };
      var removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, {
        passive: !(props.onTap || props["onPointerUp"])
      });
      var removePointerCancelListener = addPointerEvent(window, "pointercancel", function (cancelEvent, cancelInfo) {
        return _this.cancelPress(cancelEvent, cancelInfo);
      }, {
        passive: !(props.onTapCancel || props["onPointerCancel"])
      });
      _this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
      _this.startPress(startEvent, startInfo);
    };
    _this.startAccessiblePress = function () {
      var handleKeydown = function handleKeydown(keydownEvent) {
        if (keydownEvent.key !== "Enter" || _this.isPressing) return;
        var handleKeyup = function handleKeyup(keyupEvent) {
          if (keyupEvent.key !== "Enter" || !_this.checkPressEnd()) return;
          fireSyntheticPointerEvent("up", function (event, info) {
            var _this$node$getProps2 = _this.node.getProps(),
              onTap = _this$node$getProps2.onTap;
            if (onTap) {
              frame.update(function () {
                return onTap(event, info);
              });
            }
          });
        };
        _this.removeEndListeners();
        _this.removeEndListeners = addDomEvent(_this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent("down", function (event, info) {
          _this.startPress(event, info);
        });
      };
      var removeKeydownListener = addDomEvent(_this.node.current, "keydown", handleKeydown);
      var handleBlur = function handleBlur() {
        if (!_this.isPressing) return;
        fireSyntheticPointerEvent("cancel", function (cancelEvent, cancelInfo) {
          return _this.cancelPress(cancelEvent, cancelInfo);
        });
      };
      var removeBlurListener = addDomEvent(_this.node.current, "blur", handleBlur);
      _this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
    return _this;
  }
  _inherits(PressGesture, _Feature);
  return _createClass(PressGesture, [{
    key: "startPress",
    value: function startPress(event, info) {
      this.isPressing = true;
      var _this$node$getProps3 = this.node.getProps(),
        onTapStart = _this$node$getProps3.onTapStart,
        whileTap = _this$node$getProps3.whileTap;
      /**
       * Ensure we trigger animations before firing event callback
       */
      if (whileTap && this.node.animationState) {
        this.node.animationState.setActive("whileTap", true);
      }
      if (onTapStart) {
        frame.update(function () {
          return onTapStart(event, info);
        });
      }
    }
  }, {
    key: "checkPressEnd",
    value: function checkPressEnd() {
      this.removeEndListeners();
      this.isPressing = false;
      var props = this.node.getProps();
      if (props.whileTap && this.node.animationState) {
        this.node.animationState.setActive("whileTap", false);
      }
      return !isDragActive();
    }
  }, {
    key: "cancelPress",
    value: function cancelPress(event, info) {
      if (!this.checkPressEnd()) return;
      var _this$node$getProps4 = this.node.getProps(),
        onTapCancel = _this$node$getProps4.onTapCancel;
      if (onTapCancel) {
        frame.update(function () {
          return onTapCancel(event, info);
        });
      }
    }
  }, {
    key: "mount",
    value: function mount() {
      var props = this.node.getProps();
      var removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
        passive: !(props.onTapStart || props["onPointerStart"])
      });
      var removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
      this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removeStartListeners();
      this.removeEndListeners();
      this.removeAccessibleListeners();
    }
  }]);
}(Feature);
export { PressGesture };